jQuery(function ($) {

    /* ---------- Debug ---------- */
    const LOGTAG = '%cWBDM:', LOGCSS = 'color:#7b61ff;font-weight:700';
    const log  = (...a) => { try { console.debug(LOGTAG, LOGCSS, ...a); } catch(_){} };
    const warn = (...a) => { try { console.warn('WBDM:', ...a); } catch(_){} };

    // Bazowa ścieżka rodzica – bierzemy z przycisku "Wszystkie" (data-all="1")
    const WBDM_PARENT_PATH = (function () {
        try {
            const $all = $('.subcategory-tab[data-all="1"]').first();
            if ($all.length) {
                const raw = $all.data('url');
                if (raw) {
                    const u = new URL(raw, window.location.origin);
                    return u.pathname.replace(/\/+$/,'') + '/';
                }
            }

            // fallback: wytnij ostatni segment ścieżki
            const loc = new URL(window.location.href);
            const segments = loc.pathname.split('/').filter(Boolean);
            if (segments.length > 1) {
                segments.pop();
                return '/' + segments.join('/') + '/';
            }
            return loc.pathname.replace(/\/+$/,'') + '/';
        } catch (_) {
            return '/';
        }
    })();

    /* ---------- Pager CSS reset ---------- */
    (function injectPagerCSS () {
        const id = 'wbdm-pager-css-reset';
        if (document.getElementById(id)) return;
        const css = `
          .products-toolbar-footer-pagination ul.page-numbers{list-style:none;margin:0;padding:0}
          .products-toolbar-footer-pagination ul.page-numbers>li{display:inline-block;margin:0 .25rem}
          .products-toolbar-footer-pagination a.page-numbers::before,
          .products-toolbar-footer-pagination a.prev::before,
          .products-toolbar-footer-pagination a.next::before{content:none!important}
        `;
        const s = document.createElement('style');
        s.id = id; s.textContent = css; document.head.appendChild(s);
    })();

    /* ---------- SEO helpers ---------- */
    function setMetaName(name, content){ if(content==null)return; let el=document.querySelector(`meta[name="${name}"]`); if(!el){ el=document.createElement('meta'); el.setAttribute('name',name); document.head.appendChild(el);} el.setAttribute('content',String(content)); }
    function setMetaProp(prop, content){ if(content==null)return; let el=document.querySelector(`meta[property="${prop}"]`); if(!el){ el=document.createElement('meta'); el.setAttribute('property',prop); document.head.appendChild(el);} el.setAttribute('content',String(content)); }
    function setLinkRel(rel, href){ if(!href)return; let el=document.querySelector(`link[rel="${rel}"]`); if(!el){ el=document.createElement('link'); el.setAttribute('rel',rel); document.head.appendChild(el);} el.setAttribute('href',String(href)); }
    const BASE_TITLE=document.title, BASE_CANON=(document.querySelector('link[rel="canonical"]')||{}).href||window.location.href;
    const composeTitle=(prefix)=>{ const parts=BASE_TITLE.split(' – '); if(parts.length>1)parts.shift(); const suffix=parts.join(' – '); return suffix ? (prefix+' – '+suffix) : String(prefix); };
    function updateSEO({ pageUrl, name, description }) {
        const title = composeTitle(name || document.title);
        document.title = title;
        setMetaName('description', description || '');
        setLinkRel('canonical', pageUrl || BASE_CANON);
        setMetaProp('og:title', title);
        setMetaProp('og:description', description || '');
        setMetaProp('og:url', pageUrl || window.location.href);
    }

    // ---------- URL helper (pushState for subcategory clicks) ----------
    function changeUrl(pageUrl) {
        if (!pageUrl) return;
        try {
            const cleanCurrent = window.location.href.split('#')[0];
            const cleanTarget  = String(pageUrl).split('#')[0];
            if (cleanCurrent !== cleanTarget) {
                window.history.pushState(
                    { wbdm: true, url: cleanTarget },
                    '',
                    cleanTarget
                );
            }
        } catch (_) { /* no-op */ }
    }

    // Buduje URL: ZAWSZE bazuje na ścieżce rodzica + /<slug>/
    // np. /mloty-hydrauliczne/ + "mloty-hydrauliczne-male"
    //  => /mloty-hydrauliczne/mloty-hydrauliczne-male/
    function buildSubcatUrl(slug) {
        try {
            if (!slug || !String(slug).trim()) return null;

            const cleanSlug = String(slug).trim();
            const loc = new URL(window.location.href);

            const base = WBDM_PARENT_PATH.replace(/\/+$/,'');
            const finalPath = (base + '/' + cleanSlug + '/').replace(/\/{2,}/g, '/');

            loc.pathname = finalPath;
            loc.search   = ''; // bez starych ?paged, ?orderby

            return loc.toString();
        } catch (_) {
            return null;
        }
    }

    /* ---------- DOM helpers ---------- */
    const getSection      = () => $('.wp-block-wbdm-product-subcategories-product-list');
    const getProductsWrap = () => getSection().find('.product-subcategories-product-list-products-container');
    const getFooter       = () => getSection().find('.products-toolbar-footer');
    const getPager        = () => getFooter().find('.products-toolbar-footer-pagination');
    const getGridUL       = () => $('#subcategory-products').find('ul.products');

    const sortSelector = '#sort, form.woocommerce-ordering select[name="orderby"]';

    const mapWooToOur = (v) => {
        switch (String(v || '').trim()) {
            case 'menu_order': return 'default';
            case 'popularity': return 'popularity';
            case 'rating':     return 'rating';
            case 'date':       return 'date';
            case 'price':      return 'price_asc';
            case 'price-desc': return 'price_desc';
            case 'default':    return 'default';
            default:           return v || 'default';
        }
    };
    const mapUiToLogic = (v) => {
        const val = String(v || '').trim();
        if (!val) return 'default';
        if (val === 'default') return 'default';
        return mapWooToOur(val);
    };
    const mapOurToWoo = (v) => {
        switch (String(v || '').trim()) {
            case 'default':    return 'menu_order';
            case 'popularity': return 'popularity';
            case 'rating':     return 'rating';
            case 'date':       return 'date';
            case 'price_desc': return 'price-desc';
            case 'price_asc':  return 'price';
            default:           return 'menu_order';
        }
    };

    /* ---------- PERSIST SORT ---------- */
    const SORT_KEY = 'wbdm_sort_choice';
    function saveSortChoice(val){
        try { sessionStorage.setItem(SORT_KEY, String(val || 'default')); } catch(_) {}
    }
    function getSavedSortChoice(){
        try { return sessionStorage.getItem(SORT_KEY) || null; } catch(_) { return null; }
    }
    function getOrderbyFromURL(){
        try {
            const p = new URLSearchParams(window.location.search);
            const v = p.get('orderby');
            return v ? mapWooToOur(v) : null;
        } catch(_) { return null; }
    }

    function setSortUI(sortVal){
        const $woo = $('form.woocommerce-ordering select[name="orderby"]');
        const $our = $('#sort');

        if ($woo.length) {
            const wooVal = mapOurToWoo(sortVal);
            $woo.val(wooVal);
            const idx = Math.max(0, $woo.find('option').toArray().findIndex(o => o.value === wooVal));
            if (idx >= 0) $woo.prop('selectedIndex', idx);
        }
        if ($our.length) {
            const targetVal = sortVal === 'default' ? 'default' : sortVal;
            if ($our.find(`option[value="${targetVal}"]`).length) {
                $our.val(targetVal);
                const idx2 = Math.max(0, $our.find('option').toArray().findIndex(o => o.value === targetVal));
                if (idx2 >= 0) $our.prop('selectedIndex', idx2);
            }
        }
    }

    function initSortUIOnce() {
        const $our = $('#sort');
        if (!$our.length) return;
        const $first = $our.find('option').first();
        if ($first.length && $first.val() !== 'default') {
            if ($first.val() === 'price_asc' || !$first.val()) $first.val('default').attr('data-wbdm-default','1');
        }
    }

    function restoreSortUI(){
        const fromStore = getSavedSortChoice();
        const fromURL   = getOrderbyFromURL();
        const sortVal   = fromStore || fromURL || 'default';
        setSortUI(sortVal);
    }

    function currentSettings () {
        const $wrap = getProductsWrap(), $active = $('.subcategory-tab.active');
        const $sel = $(sortSelector).first();
        const uiVal = $sel.length ? $sel.val() : 'default';
        const sort = mapUiToLogic(uiVal);

        return {
            termId: Number($active.data('term-id')) || Number($wrap.data('current-term')) || 0,
            includeChildren: $active.data('all') ? 1 : (Number($wrap.data('include-children')) ? 1 : 0),
            layout: getGridUL().hasClass('list-view') ? 'list' : 'grid',
            perPage: parseInt(getFooter().find('#products-per-page-select').val(), 10) || 12,
            sort
        };
    }

    /* ---------- GRID/LIST ---------- */
    function applyView (mode) {
        const $ul = getGridUL();
        const isList = (mode === 'list');
        $ul.removeClass('grid-view list-view').addClass(isList ? 'list-view' : 'grid-view');
        getProductsWrap().find('.toggle-grid, .toggle-list')
            .removeClass('active')
            .filter(isList ? '.toggle-list' : '.toggle-grid').addClass('active');
        localStorage.setItem('wbdm_view_mode', isList ? 'list' : 'grid');
    }
    $(document).off('click.wbdmView').on('click.wbdmView', '.toggle-grid, .toggle-list', function (e) {
        e.preventDefault();
        applyView($(this).hasClass('toggle-list') ? 'list' : 'grid');
    });

    /* ---------- PAGER ---------- */
    function buildPager (totalPages, currentPage) {
        const $pager = getPager(); $pager.empty();
        totalPages = Math.max(1, parseInt(totalPages) || 1);
        currentPage = Math.min(Math.max(1, parseInt(currentPage) || 1), totalPages);
        const $ul = $('<ul/>', { class: 'page-numbers' });
        for (let i=1;i<=totalPages;i++){
            const $a=$('<a/>',{href:'#',class:'page-numbers','data-page':i,text:i});
            if(i===currentPage)$a.addClass('current').attr('aria-current','page');
            $ul.append($('<li/>').append($a));
        }
        $pager.append($ul);
    }
    function setCurrentPage (n) {
        const $pager = getPager();
        $pager.find('a.page-numbers').removeClass('current').removeAttr('aria-current');
        $pager.find(`a.page-numbers[data-page="${n}"]`).addClass('current').attr('aria-current','page');
    }

    /* ---------- Result count ---------- */
    function updateResultCountTotal (total, perPage, paged) {
        const $rc = getSection().find('.products-result-count, .products-toolbar-result-count');
        total = parseInt(total || 0, 10);
        perPage = parseInt(perPage || 12, 10);
        paged = parseInt(paged || 1, 10);
        if (!total) { $rc.text('Brak wyników'); return; }
        const from = (paged - 1) * perPage + 1;
        const to   = Math.min(total, paged * perPage);
        $rc.text(`Wyświetlanie ${from}–${to} z ${total} wyników`);
    }

    /* ---------- FIX: strip legacy "term:" on initial DOM ---------- */
    function stripLegacyTermPrefix() {
        $('select.attribute-select').each(function () {
            const $sel = $(this);
            let reselectionNeeded = false, newSelected = null;
            $sel.find('option').each(function () {
                const $opt = $(this);
                const v = $opt.val();
                if (!v) return;
                if (v.startsWith('term:')) {
                    const raw = v.slice(5);
                    const wasSelected = $opt.is(':selected');
                    $opt.val(raw);
                    if (wasSelected) { reselectionNeeded = true; newSelected = raw; }
                }
            });
            if (reselectionNeeded && newSelected !== null) $sel.val(newSelected);
        });
    }

    /* ---------- Filters from AJAX payload (with fallback) ---------- */
    function renderAttributeFilters(payloadOrOptions) {
        const $host = $('#attribute-filters');
        if (!$host.length) return;

        const opts = (payloadOrOptions && payloadOrOptions.attribute_options)
            ? payloadOrOptions.attribute_options
            : (payloadOrOptions || {});

        const attrs = (payloadOrOptions && Array.isArray(payloadOrOptions.active_attributes) && payloadOrOptions.active_attributes.length)
            ? payloadOrOptions.active_attributes
            : Object.keys(opts || {});

        const bp = payloadOrOptions?.filters_blueprint || {};

        const prevValues = {};
        $host.find('select.attribute-select').each(function(){ prevValues[this.name] = $(this).val(); });

        let html = '';
        attrs.forEach((tax) => {
            const placeholder = (window.wc_attribute_labels && wc_attribute_labels[tax]) || tax.replace(/^pa_/, '').replace(/-/g,' ').replace(/\b\w/g,c=>c.toUpperCase());
            const name = 'filter_' + tax;
            const conf = bp[tax] || { mode:'auto', values:[] };
            const list = Array.isArray(opts[tax]) ? opts[tax] : [];

            html += `<div class="attribute-filter-wrapper">`;
            html += `<select name="${name}" class="attribute-select" data-attribute="${tax}">`;
            html += `<option value="">${placeholder}</option>`;

            if (conf.mode === 'manual' && conf.values && conf.values.length) {
                conf.values.forEach(label => {
                    const val = `label:${slugify(label)}`;
                    html += `<option value="${escapeHtml(val)}">${escapeHtml(label)}</option>`;
                });
            } else {
                list.forEach(o => {
                    html += `<option value="${escapeHtml(o.slug)}">${escapeHtml(o.name)}</option>`;
                });
            }

            html += `</select></div>`;
        });

        $host.html(html);

        $host.find('select.attribute-select').each(function(){
            const prev = prevValues[this.name];
            if (prev) $(this).val(prev);
        });
    }

    function fetchFiltersOnInit(termId, includeChildren, sort, layout) {
        if (!window.WBDM_loc || !WBDM_loc.ajax_url) return Promise.resolve();
        return $.ajax({
            url: WBDM_loc.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'load_products_by_subcategory',
                term_id: termId,
                layout,
                per_page: 1,
                paged: 1,
                sort: sort === 'default' ? 'menu_order' : sort,
                include_children: includeChildren ? 1 : 0
            }
        }).then((resp) => {
            if (resp && resp.success && resp.data && resp.data.attribute_options) {
                renderAttributeFilters({
                    attribute_options: resp.data.attribute_options,
                    active_attributes: resp.data.active_attributes || undefined,
                    filters_blueprint: resp.data.filters_blueprint || undefined
                });
                normalizeAttributeSelectValues();
            }
        }).catch(()=>{ /* no-op */ });
    }

    function slugify(s){ return String(s).toLowerCase().trim().replace(/\s+/g,'-').replace(/[^a-z0-9\-]+/g,''); }
    function escapeHtml(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

    /* ---------- Normalizacja SELECTÓW ---------- */
    function normalizeAttributeSelectValues () {
        $('select.attribute-select').each(function () {
            const $sel = $(this);
            const $first = $sel.find('option').first();
            if ($first.length) $first.val('');
            if ($sel.prop('selectedIndex')===0) $sel.val('');
        });
    }

    /* ---------- Helpers ---------- */
    const isCompatTax = (tax) => tax === 'pa_kompatybilna-maszyna' || tax === 'pa_kompatybilnosc-sprzetu';
    const isWeightTax = (tax) => tax === 'pa_waga' || tax === 'pa-masa' || tax === 'pa_masa' || tax === 'pa_srednica-grota';

    function readDataAttr($el, tax) {
        const dash = 'data-' + tax.replace(/_/g,'-');
        const und  = 'data-' + tax;
        return $el.attr(dash) ?? $el.attr(und) ?? '';
    }

    function readCardWeightText($li){
        let txt = '';
        $li.find('.woocommerce-loop-product-product-attributes .woocommerce-loop-product-product-attribute-single').each(function(){
            const $name = $(this).find('.woocommerce-loop-product-product-attribute-single__name');
            const $val  = $(this).find('.woocommerce-loop-product-product-attribute-single__value');
            if ($name.length && /waga/i.test(($name.text()||'').trim())) { txt = ($val.text()||'').trim(); return false; }
        });
        return txt;
    }

    function toRange(val) {
        if (!val) return null;
        let s = String(val).toLowerCase().replace(/,/g,'.').replace(/[–—]/g,'-').replace(/\s+/g,'');
        s = s.replace(/(kg|t|tona|tony|tons|l-min|l\/min|mm)$/,'');
        const m = s.match(/^(\d+(?:\.\d+)?)(?:-(\d+(?:\.\d+)?))?$/);
        if (!m) return null;
        let a = parseFloat(m[1]), b = m[2] ? parseFloat(m[2]) : a;
        if (isNaN(a)||isNaN(b)) return null;
        if (a>b) [a,b]=[b,a];
        return {min:a,max:b};
    }

    function rangeFromSlug(slug) {
        if (!slug) return null;
        const s = String(slug).toLowerCase();
        let m = s.match(/^(\d+(?:\.\d+)?)\-([a-z0-9\-]+)\-plus$/);
        if (m) { const v = parseFloat(m[1]); return isNaN(v) ? null : {min:v, max:Infinity}; }
        m = s.match(/^(\d+(?:\.\d+)?)\-(\d+(?:\.\d+)?)(?:\-[a-z0-9\-]+)?$/);
        if (m) { const a = parseFloat(m[1]), b = parseFloat(m[2]); if (isNaN(a)||isNaN(b)) return null; return {min:Math.min(a,b), max:Math.max(b,a)}; }
        m = s.match(/^(\d+(?:\.\d+)?)\-[a-z0-9\-]+$/);
        if (m) { const v = parseFloat(m[1]); return isNaN(v) ? null : {min:v,max:v}; }
        return toRange(slug);
    }

    const rangesOverlap = (r1,r2)=> !!(r1 && r2 && !(r1.max < r2.min || r2.max < r1.min));

    const hasActiveFilters = () =>
        getProductsWrap()
            .find('select.attribute-select')
            .toArray()
            .some(s => s.selectedIndex > 0 && s.value && s.value.trim() !== '');

    function parseSelection(selValue, $select) {
        if (!selValue) return {kind:'none'};
        const v = String(selValue).trim();
        if (v.startsWith('terms:')) { const slugs = v.slice(6).split('|').map(s=>s.trim()).filter(Boolean); return {kind:'terms', slugs}; }
        if (v.startsWith('label:')) { const txt = $select.find('option:selected').text().trim(); return {kind:'label', label:txt}; }
        return {kind:'raw', value:v, label:$select.find('option:selected').text().trim()};
    }

    /* ---------- FULL POOL LOADING (NEW) ---------- */
    const FullPoolCache = Object.create(null);
    function cacheKey(termId, sort, includeChildren){ return [termId, sort, includeChildren ? 1 : 0].join('|'); }

    function ensureFullPool(termId, sort, includeChildren, layout, done) {
        const key = cacheKey(termId, sort, includeChildren);
        const $footer = getFooter();

        if (FullPoolCache[key]) {
            mountFullList(FullPoolCache[key].html, layout);
            $footer.attr({'data-full-loaded':'1','data-total': FullPoolCache[key].total, 'data-paged': 1});
            if (typeof done === 'function') done();
            return;
        }

        ajaxPage(1).then(first => {
            const maxPages = parseInt(first.max_pages, 10) || 1;
            const total    = parseInt(first.total, 10) || 0;

            const items = [];
            items.push(extractLis(first.html));

            if (maxPages <= 1) {
                const html = wrapUl(items.flat(), layout);
                FullPoolCache[key] = { html, total };
                mountFullList(html, layout);
                $footer.attr({'data-full-loaded':'1','data-total': total, 'data-paged': 1});
                if (typeof done === 'function') done();
                return;
            }

            let seq = Promise.resolve();
            for (let p = 2; p <= maxPages; p++) {
                seq = seq.then(() => ajaxPage(p).then(res => { items.push(extractLis(res.html)); }));
            }
            seq.then(() => {
                const html = wrapUl(items.flat(), layout);
                FullPoolCache[key] = { html, total };
                mountFullList(html, layout);
                $footer.attr({'data-full-loaded':'1','data-total': total, 'data-paged': 1});
                if (typeof done === 'function') done();
            });
        }).catch((e) => {
            warn('Full pool load error', e);
            if (typeof done === 'function') done();
        });

        function ajaxPage(paged){
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: (window.WBDM_loc||{}).ajax_url,
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        action: 'load_products_by_subcategory',
                        term_id: termId,
                        layout,
                        per_page: 48,
                        paged,
                        sort: sort === 'default' ? 'menu_order' : sort,
                        include_children: includeChildren ? 1 : 0
                    },
                    success: (resp) => {
                        if (!(resp && resp.success && resp.data)) return reject(new Error('bad response'));
                        resolve({ html: resp.data.html, total: resp.data.total, max_pages: resp.data.max_pages });
                    },
                    error: (xhr, st, err) => reject(err||st)
                });
            });
        }
        function extractLis(html){
            const $tmp = $('<div/>').html(html);
            return $tmp.find('ul.products > li.product').get().map(el => el.outerHTML);
        }
        function wrapUl(liArray, layoutClass){
            const cls = layoutClass === 'list' ? 'list-view' : 'grid-view';
            return `<ul class="products ${cls}">${liArray.join('')}</ul>`;
        }
        function mountFullList(fullUlHtml, layoutClass){
            $('#subcategory-products').html(fullUlHtml);
            applyView(layoutClass);
        }
    }

    /* ---------- SORTOWANIE KLIENTOWE ---------- */
    function sortGrid(sort) {
        const $ul = getGridUL();
        if (!$ul.length) return;

        if (sort === 'default') {
            const $footer = getFooter();
            const per = parseInt($footer.find('#products-per-page-select').val(),10) || 12;
            $footer.attr('data-paged', 1);
            buildPager(Math.max(1, Math.ceil($ul.children('li.product').length / per)), 1);
            return;
        }

        const $items = $ul.children('li.product').get();

        const val = (el, attr, def = 0) => {
            const v = $(el).attr(attr);
            if (attr === 'data-date') return v || '';
            const n = parseFloat(v);
            return Number.isFinite(n) ? n : def;
        };

        const cmpNumAsc  = (a,b,attr) => val(a,attr) - val(b,attr);
        const cmpNumDesc = (a,b,attr) => val(b,attr) - val(a,attr);
        const cmpDateDesc= (a,b) => (val(b,'data-date','') > val(a,'data-date','')) ? 1 : (val(b,'data-date','') < val(a,'data-date','') ? -1 : 0);

        switch (sort) {
            case 'price_desc': $items.sort((a,b)=>cmpNumDesc(a,b,'data-price')); break;
            case 'popularity': $items.sort((a,b)=>cmpNumDesc(a,b,'data-sales')); break;
            case 'rating':     $items.sort((a,b)=>cmpNumDesc(a,b,'data-rating')); break;
            case 'price_asc':  $items.sort((a,b)=>cmpNumAsc(a,b,'data-price')); break;
            case 'date':
            default:           $items.sort(cmpDateDesc); break;
        }

        $ul.empty().append($items);

        const $footer = getFooter();
        const per = parseInt($footer.find('#products-per-page-select').val(),10) || 12;
        $footer.attr('data-paged', 1);
        buildPager(Math.max(1, Math.ceil($items.length / per)), 1);
    }

    /* ---------- Filtry (client-side) ---------- */
    function applyFilters (forceToPage1 = true) {
        const $footer = getFooter();
        const $ul     = getGridUL();
        const $items  = $ul.find('li.product');
        $items.each(function(){ this.style.display = ''; });

        if (!$items.length) return;

        if (!hasActiveFilters()) {
            $items.show();
            const per   = parseInt($footer.find('#products-per-page-select').val(),10) || 12;
            updateResultCountTotal($items.length, per, 1);
            buildPager(Math.max(1, Math.ceil($items.length/per)), 1);
            setCurrentPage(1);
            return;
        }

        const filters = getProductsWrap().find('select.attribute-select').toArray()
            .map(sel => {
                const $sel = $(sel);
                if (!sel.value || sel.selectedIndex===0) return null;
                return { tax: $sel.data('attribute'), parsed: parseSelection(sel.value, $sel) };
            })
            .filter(Boolean);

        const visible = [];

        $items.each(function(){
            let ok = true;
            const $li = $(this);

            for (const f of filters) {
                const tax = String(f.tax || '');
                let raw = readDataAttr($li, tax);
                if ((!raw || !String(raw).trim()) && isWeightTax(tax)) raw = readCardWeightText($li);
                if (!raw) { ok = false; break; }

                const rawTokens = String(raw).toLowerCase().split(/[,\s;/]+/).filter(Boolean);

                if (isCompatTax(tax) || isWeightTax(tax)) {
                    let selectedRanges = [];
                    switch (f.parsed.kind) {
                        case 'label': { const r = toRange(f.parsed.label); if (r) selectedRanges.push(r); break; }
                        case 'terms': { f.parsed.slugs.forEach(s => { const r = rangeFromSlug(s); if (r) selectedRanges.push(r); }); break; }
                        case 'raw':   { const r = rangeFromSlug(f.parsed.value) || toRange(f.parsed.value) || toRange(f.parsed.label); if (r) selectedRanges.push(r); break; }
                    }
                    if (!selectedRanges.length) { ok = false; break; }
                    const prodRanges = rawTokens.map(tok => rangeFromSlug(tok) || toRange(tok)).filter(Boolean);
                    if (!prodRanges.length) { ok = false; break; }
                    const hit = selectedRanges.some(sr => prodRanges.some(pr => rangesOverlap(pr, sr)));
                    if (!hit) { ok = false; break; }
                } else {
                    let wanted = [];
                    switch (f.parsed.kind) {
                        case 'terms': wanted = f.parsed.slugs.map(s=>s.toLowerCase()); break;
                        case 'label': wanted = [slugify(f.parsed.label)]; break;
                        case 'raw':   wanted = [f.parsed.value.toLowerCase()]; break;
                    }
                    const productSlugs = rawTokens.map(slugify);
                    const any = wanted.some(w => productSlugs.includes(slugify(w)));
                    if (!any) { ok = false; break; }
                }
            }

            if (ok) visible.push(this);
        });

        if (visible.length === 0) {
            $items.hide();
            $('#subcategory-products').html(`<p class="no-products-found">Brak produktów spełniających wybrane parametry.</p>`);
            buildPager(1, 1);
            updateResultCountTotal(0, 0, 1);
            return;
        }

        const per = parseInt($footer.find('#products-per-page-select').val(),10) || 12;
        let cur  = parseInt($footer.attr('data-paged'),10) || 1;
        if (forceToPage1) cur = 1;

        const totalPages = Math.max(1, Math.ceil(visible.length / per));
        if (cur > totalPages) cur = totalPages;

        $items.hide();
        $(visible).slice((cur-1)*per, cur*per).show();

        updateResultCountTotal(visible.length, per, cur);
        buildPager(totalPages, cur);
        $footer.attr('data-total', visible.length).attr('data-paged', cur);
        setCurrentPage(cur);
    }

    /* ---------- AJAX load + HERO + BLOKI + SEO + URL ---------- */
    function loadSubcat (termId, layout, perPage, paged, sort, includeChildren, pageUrl) {
        if (!window.WBDM_loc || !WBDM_loc.ajax_url) { warn('Missing ajax_url'); return; }

        $.ajax({
            url: WBDM_loc.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'load_products_by_subcategory',
                term_id: termId,
                layout,
                per_page: perPage,
                paged,
                sort: sort === 'default' ? 'menu_order' : sort,
                include_children: includeChildren ? 1 : 0
            },
            beforeSend () {
                $('#subcategory-products').html(
                    `<ul class="products ${layout === 'list' ? 'list-view' : 'grid-view'}"><li>Ładowanie produktów…</li></ul>`
                );
            },
            success (resp) {
                if (!(resp && resp.success && resp.data)) {
                    $('#subcategory-products').html('<ul class="products"><li>Wystąpił błąd…</li></ul>');
                    return;
                }

                // FILTRY
                renderAttributeFilters(resp.data);

                // PRODUKTY
                $('#subcategory-products').html(resp.data.html);

                const $ul    = $('#subcategory-products ul.products');
                const $items = $ul.find('li.product');
                $items.each(function(){ this.style.display = ''; }).show();

                normalizeAttributeSelectValues();

                const savedMode = localStorage.getItem('wbdm_view_mode') || 'grid';
                applyView(savedMode);

                const $footer = getFooter();
                const serverTotal = parseInt(resp.data.total, 10);
                const total  = Number.isFinite(serverTotal) ? serverTotal : $items.length;

                const per = parseInt(resp.data.per_page, 10)
                    || parseInt(typeof perPage !== 'undefined' ? perPage : NaN, 10)
                    || parseInt($footer.attr('data-per-page'), 10)
                    || 12;

                const cur   = parseInt(resp.data.paged, 10) || 1;
                const maxPg = parseInt(resp.data.max_pages, 10) || Math.max(1, Math.ceil(total / per));

                getProductsWrap().find('#products-per-page-select, .products-per-page-select').val(per);
                $footer.attr({ 'data-total': total, 'data-per-page': per, 'data-paged': cur, 'data-full-loaded': '0' });

                buildPager(maxPg, cur);
                updateResultCountTotal(total, per, cur);

                if (resp.data.subcategory_title) {
                    $('.product-subcategories-product-list__title').text(resp.data.subcategory_title);
                }
                if (resp.data.subcategory_description) {
                    $('.product-subcategories-product-list__text').html(resp.data.subcategory_description);
                }

                /* ===== PODMIANA BLOKÓW Z SZABLONU TAKSONOMII ===== */

                // Hero product category
                if (resp.data.hero_block_html) {
                    const $hero = $('.hero-product-category-block');
                    if ($hero.length) {
                        $hero.replaceWith(resp.data.hero_block_html);
                    }
                }

                // Video slider
                if (resp.data.video_slider_block_html) {
                    const $vs = $('.video-slider-block');
                    let $newBlock = null;

                    if ($vs.length) {
                        // replace block → zwraca nowy element
                        $newBlock = $(resp.data.video_slider_block_html);
                        $vs.replaceWith($newBlock);
                    }

                    // Re-init slider TYLKO dla nowego bloku
                    if (window.wbdmInitVideoSlider) {
                        window.wbdmInitVideoSlider($newBlock || document);
                    }
                }


                // Quote two col
                if (resp.data.quote_two_col_block_html) {
                    const $qt = $('.quote-two-col-block');
                    if ($qt.length) {
                        $qt.replaceWith(resp.data.quote_two_col_block_html);
                    }
                }

                // Title with text
                if (resp.data.title_with_text_block_html) {
                    const $tt = $('.title-with-text-block');
                    if ($tt.length) {
                        $tt.replaceWith(resp.data.title_with_text_block_html);
                    }
                }

                // Breadcrumbs (Yoast)
                if (resp.data.breadcrumbs_html) {
                    const $bc = $('.breadcrumbs-container-product-category');
                    if ($bc.length) {
                        $bc.replaceWith(resp.data.breadcrumbs_html);
                    } else {
                        // fallback: prepend near hero
                        $('.hero-product-category-block').first().before(resp.data.breadcrumbs_html);
                    }
                }

                // SEO + URL
                updateSEO({
                    pageUrl: pageUrl,
                    name: resp.data?.subcategory_title,
                    description: resp.data?.subcategory_description
                });
                changeUrl(pageUrl);

                // Re-init zachowań kart
                setupCardBehavior();

                // Przywróć sortowanie
                restoreSortUI();

                // Re-init JS bloków (jeśli globalne init-y istnieją)
                if (window.wbdmInitVideoSlider) {
                    window.wbdmInitVideoSlider();
                }
                if (window.wbdmInitHeroProductCategory) {
                    window.wbdmInitHeroProductCategory();
                }
                if (window.wbdmInitQuoteTwoCol) {
                    window.wbdmInitQuoteTwoCol();
                }
                if (window.wbdmInitTitleWithText) {
                    window.wbdmInitTitleWithText();
                }

                // Filtry full-pool po stronie klienta
                if (hasActiveFilters()) {
                    const s = currentSettings();
                    ensureFullPool(s.termId, s.sort, s.includeChildren, s.layout, () => applyFilters(true));
                }
            },
            error (xhr, status, err) { warn('AJAX error', status, err); }
        });
    }

    /* ---------- Hover / click card behavior ---------- */
    function setupCardBehavior () {
        $(document).off('.wbdmCard');
        const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.matchMedia('(min-width: 900px)').matches;
        if (hoverCapable) {
            $(document)
                .on('mouseenter.wbdmCard', 'ul.products li.product', function () {
                    $(this).closest('ul.products').find('li.product').removeClass('with-button');
                    $(this).addClass('with-button');
                })
                .on('mouseleave.wbdmCard', 'ul.products li.product', function () {
                    $(this).removeClass('with-button');
                });
        }
    }

    /* ---------- SYNC TABS Z AKTUALNYM URL ---------- */
    function syncTabsWithLocation() {
        const $tabs = $('.subcategory-tab');
        if (!$tabs.length) return;

        let path;
        try {
            const loc = new URL(window.location.href);
            path = loc.pathname.replace(/\/+$/,'') + '/';
        } catch(_) {
            return;
        }

        const parent = WBDM_PARENT_PATH.replace(/\/+$/,'') + '/';
        let $target = null;

        if (path === parent) {
            // URL = dokładnie rodzic -> aktywny tylko "Wszystkie"
            $target = $tabs.filter('[data-all="1"]').first();
        } else {
            // URL z podkategorią -> znajdź odpowiadający tab
            const segments = path.split('/').filter(Boolean);
            const slug = segments[segments.length - 1];

            // 1) po data-slug
            $target = $tabs.filter(function () {
                const ds = $(this).data('slug');
                return ds && String(ds) === slug;
            }).first();

            // 2) fallback: po data-url (ostatni segment ścieżki)
            if (!$target.length) {
                $tabs.each(function () {
                    const raw = $(this).data('url');
                    if (!raw) return;
                    try {
                        const u = new URL(raw, window.location.origin);
                        const segs = u.pathname.replace(/\/+$/,'').split('/').filter(Boolean);
                        const last = segs[segs.length - 1] || null;
                        if (last === slug) {
                            $target = $(this);
                            return false; // break .each
                        }
                    } catch(_) {}
                });
            }

            // 3) fallback ostateczny: "Wszystkie"
            if (!$target.length) {
                $target = $tabs.filter('[data-all="1"]').first();
            }
        }

        if ($target && $target.length) {
            $tabs.removeClass('active');
            $target.addClass('active');
        }
    }

    /* ---------- Zdarzenia ---------- */

    // blokada natywnego submit/orderby Woo
    $(document)
        .off('submit.wbdmOrdering')
        .on('submit.wbdmOrdering', 'form.woocommerce-ordering', function(e){
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        });

    $(document)
        .off('change.wbdmOrdering input.wbdmOrdering')
        .on('change.wbdmOrdering input.wbdmOrdering', 'form.woocommerce-ordering select[name="orderby"]', function(e){
            e.preventDefault();
            e.stopImmediatePropagation();

            const sortVal = mapWooToOur(this.value);
            saveSortChoice(sortVal);
            setSortUI(sortVal);

            $(this).trigger('wbdm:sort-change');
        });

    $(document)
        .off('change.wbdmSort input.wbdmSort wbdm:sort-change.wbdmSort')
        .on('change.wbdmSort input.wbdmSort wbdm:sort-change.wbdmSort', sortSelector, function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const target = e.currentTarget || this;
            const rawVal = $(target).val();
            const sortLogic = mapUiToLogic(rawVal);

            saveSortChoice(sortLogic);
            setSortUI(sortLogic);

            const s = currentSettings();
            const $footer = getFooter();

            if ($footer.attr('data-full-loaded') === '1' || hasActiveFilters()) {
                sortGrid(s.sort);
                applyFilters(true);
                return;
            }
            $footer.attr('data-full-loaded','0');
            loadSubcat(s.termId, s.layout, s.perPage, 1, s.sort, s.includeChildren);
        });

    // Filtry
    $(document)
        .off('change.wbdmAttr input.wbdmAttr')
        .on('change.wbdmAttr input.wbdmAttr', 'select.attribute-select', function () {
            const $footer = getFooter();
            $footer.attr('data-paged', 1);
            const s = currentSettings();
            if (!hasActiveFilters()) {
                $footer.attr('data-full-loaded', '0');
                loadSubcat(s.termId, s.layout, s.perPage, 1, s.sort, s.includeChildren);
            } else {
                if ($footer.attr('data-full-loaded') !== '1') {
                    ensureFullPool(s.termId, s.sort, s.includeChildren, s.layout, () => applyFilters(true));
                } else {
                    applyFilters(true);
                }
            }
        });

    // Paginacja
    $(document).on('click', '.products-toolbar-footer-pagination a.page-numbers', function (e) {
        e.preventDefault();
        const n = parseInt($(this).attr('data-page'), 10) || 1;
        const s = currentSettings();

        setCurrentPage(n);
        getFooter().attr('data-paged', n);

        // *** SCROLL NA GÓRĘ LISTY PRODUKTÓW ***
        const $section = getSection(); // cały blok z listą
        if ($section.length) {
            // jeśli masz sticky header, możesz skorygować np. o 100px
            const offsetTop = $section.offset().top - 100;
            $('html, body').animate({ scrollTop: offsetTop }, 300);
        }

        if (hasActiveFilters()) {
            applyFilters(false);
        } else {
            loadSubcat(s.termId, s.layout, s.perPage, n, s.sort, s.includeChildren);
        }
    });


    // Zmiana zakładki
    $(document).on('click', '.subcategory-tab', function (e) {
        e.preventDefault();

        $('.subcategory-tab').removeClass('active');
        $(this).addClass('active');

        const s = currentSettings();
        buildPager(1, 1);
        getFooter().attr({ 'data-full-loaded': '0', 'data-paged': 1 });

        const isAll = !!$(this).data('all');
        let pageUrl = null;

        if (isAll) {
            // "Wszystkie" – tylko URL rodzica
            try {
                const loc = new URL(window.location.href);
                loc.pathname = WBDM_PARENT_PATH;
                loc.search   = '';
                pageUrl = loc.toString();
            } catch (_) {
                pageUrl = window.location.origin.replace(/\/+$/,'') + WBDM_PARENT_PATH;
            }
        } else {
            let slug = $(this).data('slug');

            if (slug && /^\d+$/.test(String(slug))) {
                slug = null;
            }

            if (!slug) {
                const rawUrl = $(this).data('url');
                if (rawUrl) {
                    try {
                        const u = new URL(rawUrl, window.location.origin);
                        const segments = u.pathname.replace(/\/+$/,'').split('/').filter(Boolean);
                        slug = segments[segments.length - 1] || null;
                    } catch (_) { /* no-op */ }
                }
            }

            pageUrl = buildSubcatUrl(slug);
        }

        loadSubcat(s.termId, s.layout, s.perPage, 1, s.sort, s.includeChildren, pageUrl);
    });

    // Per-page
    $(document).off('change.wbdmPer').on('change.wbdmPer', '#products-per-page-select, .products-per-page-select', function () {
        const per = parseInt(this.value, 10) || 12;
        const $wrap = getProductsWrap();
        const $footer = getFooter();

        $wrap.find('#products-per-page-select, .products-per-page-select').val(per);
        $footer.attr('data-per-page', per).attr('data-paged', 1);

        const s = currentSettings();
        if (hasActiveFilters()) {
            applyFilters(true);
        } else {
            loadSubcat(s.termId, s.layout, per, 1, s.sort, s.includeChildren);
        }
    });

    /* ---------- Init ---------- */
    (function init () {
        const $footer = getFooter();

        stripLegacyTermPrefix();
        initSortUIOnce();

        $('form.woocommerce-ordering').attr('onsubmit','return false;');

        const total = parseInt($footer.attr('data-total'), 10);
        const per   = parseInt($footer.attr('data-per-page'), 10) || 12;
        const cur   = parseInt($footer.attr('data-paged'), 10) || 1;

        restoreSortUI();
        syncTabsWithLocation();

        const s0 = currentSettings();

        // sprawdzamy czy jesteśmy na URL rodzica czy na podkategorii
        const locPath    = window.location.pathname.replace(/\/+$/,'') + '/';
        const parentPath = WBDM_PARENT_PATH.replace(/\/+$/,'') + '/';
        const isChildUrl = (locPath !== parentPath);

        if (isChildUrl) {
            // od razu ładujemy wszystko AJAX-em dla aktywnej podkategorii
            $footer.attr({ 'data-full-loaded': '0', 'data-paged': cur });
            loadSubcat(s0.termId, s0.layout, per, cur, s0.sort, s0.includeChildren, window.location.href);
        } else {
            // stary tryb – możemy policzyć paginację z atrybutów / HTML
            let totalPages = parseInt($footer.attr('data-total-pages'), 10);
            if (!totalPages) {
                const initialCount = total || $('#subcategory-products ul.products li.product').length || 0;
                totalPages = Math.max(1, Math.ceil(initialCount / per));
            }

            buildPager(totalPages, cur);

            fetchFiltersOnInit(s0.termId, s0.includeChildren, s0.sort, s0.layout).then(() => {
                normalizeAttributeSelectValues();
                if (hasActiveFilters()) {
                    ensureFullPool(s0.termId, s0.sort, s0.includeChildren, s0.layout, () => applyFilters(true));
                } else {
                    updateResultCountTotal(total || $('#subcategory-products ul.products li.product').length, per, cur);
                }
            });
        }

        const savedMode = localStorage.getItem('wbdm_view_mode') || 'grid';
        applyView(savedMode);

        setupCardBehavior();

        log('init complete', { isChildUrl, mode: savedMode, parentPath: WBDM_PARENT_PATH });
    })();


});
